// extracted by mini-css-extract-plugin
export default {"container":"Article_container__hGDQH"};